import { isEmpty } from 'lodash-es';

import * as angular from 'angular';

export default function ChartServicesService($log, $filter, highChartDefaults) {
  'ngInject';

  function allocationColor(underAllocated) {
    return underAllocated ? '#F7E4A9' : '#EEF7E4';
  }

  return {
    /**
     * This was formerly in the purchasePlanChartFilters.js and there is still a wrapper function there which calls
     * this one so existing code doesn't have to change, but it has been extracted so it could be reused across many
     * pages which may need to show the larger zoomed version of the micro-chart.
     *
     * @param seller
     * @param terms
     * @param allocations
     * @returns {*}
     */
    getSellerToCompareConfig: function (seller, terms, allocations) {
      if (typeof terms.sellers[0] == 'undefined') {
        return false;
      }

      var pricingChartSmallDefaults =
        highChartDefaults.pricingChartSmallDefaults;
      var selectedBenchMarkType = seller.selectedBenchMarkType;
      var benchmarksinfo = selectedBenchMarkType
        ? seller.benchmarks[selectedBenchMarkType]
        : {};
      var benchmarkYAxisRange;
      var seriesArray: any = [];
      var multiplier = -100;
      var benchmarkAxisOverride: any = {
        yAxis: {}
      };
      var exactPriceX = 0;
      var axisDefault = 11;
      var axisOverride;
      var underAllocated = true;
      var targetMarketShare;
      var currentMarketShare;
      var exactPrice =
        terms.sellers[0].marketTerms[0].pricingTerms[0].exactPrice ||
        allocations.exactPrice;
      var exactPricePct =
        terms.sellers[0].marketTerms[0].pricingTerms[0].exactPricePct ||
        allocations.exactPricePct;
      var exactPriceMarkerY;
      var maxYaxisRange =
        terms.sellers[0].maxYAxisRange || terms.sellers[0].sellerMaxYAxisRange;

      allocations = allocations || {};

      if (allocations.targetMarketShare != null) {
        targetMarketShare = allocations.targetMarketShare / 10;
      }

      if (allocations.marketShare != null) {
        currentMarketShare = allocations.marketShare / 10;
      }

      if (!isEmpty(benchmarksinfo)) {
        var bestPrice = benchmarksinfo.best * multiplier;
        var averagePrice = benchmarksinfo.average * multiplier;

        benchmarkAxisOverride.yAxis.plotBands = [
          {
            from: averagePrice,
            to: bestPrice, // higher value
            color: '#e0b0b0',
            id: selectedBenchMarkType
          }
        ];

        if (Math.abs(averagePrice) > Math.abs(bestPrice)) {
          benchmarkYAxisRange = Math.abs(averagePrice);
        } else {
          benchmarkYAxisRange = Math.abs(bestPrice);
        }

        if (benchmarkYAxisRange > axisDefault / 1.3) {
          benchmarkAxisOverride.yAxis.max = benchmarkYAxisRange * 1.4;
          benchmarkAxisOverride.yAxis.min = benchmarkYAxisRange * -1.4;
          benchmarkAxisOverride.yAxis.tickInterval = benchmarkYAxisRange * 2.8;
        }
      }

      if (
        terms.sellers &&
        terms.sellers[0].sellerMaxYAxisRange &&
        terms.sellers[0].sellerMaxYAxisRange > 11
      ) {
        axisOverride = {
          yAxis: {
            max: maxYaxisRange * 1.4,
            min: maxYaxisRange * -1.4,
            tickInterval: maxYaxisRange * 2.8,
            plotLines: [
              {
                color: '#c0c0c0',
                value: 0,
                width: 1,
                zIndex: 2,
                id: 'zeroline'
              }
            ]
          }
        };
      } else {
        axisOverride = {
          yAxis: {
            max: axisDefault * 1.4,
            min: axisDefault * -1.4,
            tickInterval: axisDefault * 2.8,
            plotLines: [
              {
                color: '#c0c0c0',
                value: 0,
                width: 1,
                zIndex: 2,
                id: 'zeroline'
              }
            ]
          }
        };
      }

      // logic from processGraphData to parse JSON into series data

      var loSeriesData: any[] = [];
      var hiSeriesData: any[] = [];
      var bestPricingOffer;
      var bestPricingOfferPoint;
      var bestPricingOfferMarker;
      var termData = terms.sellers[0].marketTerms[0].pricingTerms[0];

      for (var i = 0; i < 10; i++) {
        // Assign each data point to the correct series
        if (termData.minPct[i] >= 0 && termData.maxPct[i] > 0) {
          hiSeriesData[i] = {
            x: i,
            low: termData.minPct[i],
            high: termData.maxPct[i]
          };
          loSeriesData[i] = { x: i, low: null, high: null };
        } else if (termData.minPct[i] < 0 && termData.maxPct[i] <= 0) {
          hiSeriesData[i] = { x: i, low: null, high: null };
          loSeriesData[i] = {
            x: i,
            low: termData.minPct[i],
            high: termData.maxPct[i]
          };
          if (targetMarketShare === i) {
            loSeriesData[i].color = pricingChartSmallDefaults.colors[1];
          }
        } else {
          hiSeriesData[i] = {
            x: i,
            low: termData.minPct[i],
            high: termData.maxPct[i]
          };

          loSeriesData[i] = {
            x: i,
            low: termData.minPct[i],
            high: 0,
            borderColor: pricingChartSmallDefaults.colors[2]
          };
        }

        if (targetMarketShare === i) {
          if (typeof exactPricePct != 'undefined') {
            exactPriceMarkerY = exactPricePct;
          } else {
            if (terms.spendLast12Months > 0) {
              // this determines the y position of exact price marker
              exactPriceMarkerY = (exactPrice / terms.spendLast12Months) * 100;
            }
          }

          exactPriceX = i;
          hiSeriesData[i].color = pricingChartSmallDefaults.colors[0];
          loSeriesData[i].color = pricingChartSmallDefaults.colors[1];
        }

        // TODO: best offer should be determined in the backend
        // best offer is lowest price at lowest market share
        if (
          typeof bestPricingOffer == 'undefined' ||
          (bestPricingOffer > termData.minPct[i] && termData.minPct[i])
        ) {
          bestPricingOffer = termData.minPct[i];
          bestPricingOfferPoint = i;

          if (bestPricingOffer < 0) {
            bestPricingOfferMarker =
              'url(/aptitude/images/bestPriceMarker16x16.png)';
          } else {
            bestPricingOfferMarker =
              'url(/aptitude/images/bestPriceMarker_loss16x16.png)';
          }
        }
      }

      seriesArray.push({
        id: 'hiSeries',
        title: 'HiSeries',
        color: '#ffffff',
        borderColor: pricingChartSmallDefaults.colors[0],
        data: hiSeriesData
      });
      seriesArray.push({
        id: 'loSeries',
        title: 'LoSeries',
        color: '#ffffff',
        borderColor: pricingChartSmallDefaults.colors[1],
        data: loSeriesData
      });
      seriesArray.push({
        id: 'bestOffer',
        title: 'BestOffer',
        type: 'scatter',
        zIndex: 3,
        marker: {
          enabled: true,
          symbol: bestPricingOfferMarker
        },
        data: [[bestPricingOfferPoint, bestPricingOffer]]
      });

      if (
        typeof currentMarketShare !== 'undefined' &&
        typeof targetMarketShare !== 'undefined' &&
        currentMarketShare >= targetMarketShare
      ) {
        underAllocated = false;
      }

      if (typeof currentMarketShare !== 'undefined') {
        benchmarkAxisOverride.xAxis = {
          plotLines: [
            {
              width: 1,
              color: '#4ac6eb',
              value: currentMarketShare,
              zIndex: 1,
              id: 'currentAllocation'
            }
          ]
        };

        if (currentMarketShare > 0) {
          benchmarkAxisOverride.xAxis.plotBands = [
            {
              color: allocationColor(underAllocated),
              from: -1,
              to: currentMarketShare,
              id: 'currentAllocationBand'
            }
          ];
        }

        seriesArray.push({
          type: 'scatter',
          id: 'currentAllocationText',
          marker: {
            enabled: true,
            radius: 0
          },
          data: [[currentMarketShare > 9 ? 9 : currentMarketShare, 0]],
          dataLabels: {
            enabled: false,
            verticalAlign: 'top',
            color: '#4ac6eb',
            y: 0,
            format: `${Math.ceil(currentMarketShare * 10)}`,
            useHTML: true,
            crop: false,
            overflow: 'none'
          }
        });
      }

      return $.extend(
        true,
        {},
        pricingChartSmallDefaults,
        { series: seriesArray },
        benchmarkAxisOverride,
        axisOverride,
        { sourceData: { targetMarketShare: targetMarketShare * 10 } }
      );
    },

    /**
     * This was formerly in the pricingGraphModal.js and there is still a function there which calls this one so the
     * rest of the code there doesn't have to change. This has been extracted though because I'm hoping to use it
     * multiple places.
     *
     * @param componentData
     * @param graphData
     * @param allBuyers
     * @param likeMe
     * @param shimAmounts
     * @param disableHover
     * @returns {
     *   {
     *     chart: {
     *       events: {}
     *     },
     *     tooltip: {
     *       animation: boolean,
     *       shared: boolean,
     *       borderRadius: number,
     *       borderWidth: number,
     *       backgroundColor: string,
     *       useHTML: boolean,
     *       followPointer: boolean,
     *       positioner: positioner,
     *       formatter: formatter
     *     },
     *     xAxis: {
     *       plotLines: Array,
     *       plotBands: {}
     *     },
     *     yAxis: {
     *       plotLines: Array,
     *       plotBands: {}
     *     },
     *     plotOptions: {
     *       series: {
     *         cursor: string
     *       }
     *     }
     *   }
     * }
     */
    createGraphData: function (
      componentData,
      graphData,
      allBuyers,
      likeMe,
      shimAmounts,
      backupTargetMarketShare
    ) {
      var targetMarketShare = backupTargetMarketShare;
      var underAllocated = true;
      var bigGraphInfo: any = {
        chart: {
          height: 335,
          width: 575,
          type: 'columnrange',
          plotBackgroundColor: '#ffffff',
          borderWidth: 0,
          plotBorderWidth: 1,
          marginTop: 6,
          showAxes: true
        },
        colors: [
          '#c77329',
          '#8ac342',
          {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, 'rgba(255,255,255,.002)'],
              [0.05, 'rgba(255,255,255,.002)'],
              [0.05, '#8ac342'],
              [1, '#8ac342']
            ]
          }
        ],
        plotOptions: {
          columnrange: {
            borderWidth: 2,
            pointWidth: 14,
            grouping: false,
            groupPadding: 0,
            minPointLength: 4,
            enableMouseTracking: false,
            zIndex: 3,
            states: {
              hover: {
                enabled: false
              }
            },
            events: {
              // Kludge to fix an apparent highcharts bug - see APT-6970
              mouseOver: function () {
                $('.highcharts-tooltip').css('visibility', 'visible');
              },
              mouseOut: function () {
                $('.highcharts-tooltip').css('visibility', 'hidden');
              }
            }
          },
          scatter: {
            zIndex: 5,
            enableMouseTracking: false,
            states: {
              hover: {
                enabled: false
              }
            },
            events: {
              // Kludge to fix an apparent highcharts bug - see APT-6970
              mouseOver: function () {
                $('.highcharts-tooltip').css('visibility', 'visible');
              },
              mouseOut: function () {
                $('.highcharts-tooltip').css('visibility', 'hidden');
              }
            },
            color: 'transparent',
            marker: {
              symbol: 'circle',
              radius: 0
            }
          }
        },
        yAxis: {
          labels: {
            enabled: true,
            useHTML: true,
            step: 1,
            formatter: function () {
              if (this.isFirst) {
                return '<span style="color:#8ac342;font-size:12px">Lower</span>';
              } else if (this.isLast) {
                return '<span style="color:#c77329;font-size:12px">Higher</span>';
              } else if (this.value === 0) {
                return null;
              } else {
                return Math.abs(this.value) + '%';
              }
            },
            x: -18
          },
          plotLines: [
            {
              color: '#c0c0c0',
              width: 1,
              value: 0,
              zIndex: 4
            }
          ],
          plotBands: [
            {
              color: '#e0b0b0'
            }
          ],
          gridLineWidth: 0,
          tickWidth: 0,
          title: {
            text: 'Current',
            rotation: 0,
            offset: 50,
            style: {
              fontWeight: 'normal',
              color: '#999999'
            }
          }
        },
        xAxis: {
          labels: {
            enabled: true,
            step: 1,
            useHTML: true,
            formatter: function () {
              if (this.value > 0) {
                return (
                  '<span class="chartlabel ' +
                  this.value +
                  '">' +
                  this.value * 10 +
                  '%</span>'
                );
              } else {
                return '<span class="chartlabel 0"><10%</span>';
              }
            },
            y: 20
          },
          gridLineWidth: 0,
          tickInterval: 1,
          tickWidth: 0,
          min: 0,
          max: 9,
          plotLines: [
            {
              color: '#4ac6eb',
              width: 2,
              zIndex: 3
            }
          ],
          title: {
            text: 'Market Share',
            style: {
              fontWeight: 'normal',
              color: '#999999'
            },
            margin: 16
          }
        },
        series: angular.copy(graphData.series),
        credits: {
          enabled: false
        },
        title: {
          text: null
        },
        legend: {
          enabled: false
        },
        tooltip: {
          enabled: false
        }
      };

      // Swap out smaller markers in the graph for larger ones.
      $.each(bigGraphInfo.series, function (index, val) {
        if (
          bigGraphInfo.series[index].marker &&
          bigGraphInfo.series[index].marker.symbol ==
            'url(/aptitude/images/bestPriceMarker16x16.png)'
        ) {
          bigGraphInfo.series[index].marker.symbol =
            'url(/aptitude/images/bestPriceMarker40x40.png)';
        }
        if (
          bigGraphInfo.series[index].marker &&
          bigGraphInfo.series[index].marker.symbol ==
            'url(/aptitude/images/bestPriceMarker_loss16x16.png)'
        ) {
          bigGraphInfo.series[index].marker.symbol =
            'url(/aptitude/images/bestPriceMarker_loss40x40.png)';
        }
        if (
          bigGraphInfo.series[index].marker &&
          bigGraphInfo.series[index].marker.symbol ==
            'url(/aptitude/images/exactPriceMarkerSmall.png)'
        ) {
          // While we're here, grab the targetMarketShare
          targetMarketShare = bigGraphInfo.series[index].data[0][0] * 10;
          bigGraphInfo.series[index].marker.symbol =
            'url(/aptitude/images/exactPriceMarker.png)';
          bigGraphInfo.series[index].zIndex = 25;
          bigGraphInfo.series[index].enableMouseTracking = false;
        }
      });

      // This query is more complicated than it needs to be and the reason is that the data structure on the Purchase
      // Planning page has an allocation section which is not present for the same data structure on the Offer Impact
      // page. Both are coming from the back-end but they lack equivalence. This code smooths over that and uses
      // the right number in both cases.
      if (
        typeof componentData.marketShare !== 'undefined' &&
        typeof targetMarketShare !== 'undefined' &&
        ((componentData.allocation != null &&
          componentData.allocation.marketShare >= targetMarketShare) ||
          (componentData.allocation == null &&
            componentData.marketShare >= targetMarketShare))
      ) {
        // Green (isn't everything great) color
        underAllocated = false;
      } else {
        // Orange (underperforming) color
        underAllocated = true;
      }

      // These are fallbacks, we're resetting later based on yAxisRange.
      bigGraphInfo.yAxis.max = graphData.yAxis.max;
      bigGraphInfo.yAxis.min = graphData.yAxis.min;
      var yAxisRange = 11;

      // We pulled all the series data over wholesale from the other chartServices function results. Now we look for
      // info to help set the Y axis range.

      // Set range based on data extremes
      $.each(bigGraphInfo.series, function (index, value) {
        var i;

        if (value.id == 'hiSeries') {
          for (i = 0; i < value.data.length; i++) {
            if (value.data[i].high > yAxisRange) {
              yAxisRange = Math.ceil(value.data[i].high * 1.05);
            }
          }
        }

        if (value.id == 'loSeries') {
          for (i = 0; i < value.data.length; i++) {
            if (Math.abs(value.data[i].low) > yAxisRange) {
              yAxisRange = Math.ceil(Math.abs(value.data[i].low) * 1.05);
            }
          }
        }

        if (value.id == 'exactPrice') {
          for (i = 0; i < value.data.length; i++) {
            if (Math.abs(value.data[0][1]) > yAxisRange) {
              yAxisRange = Math.ceil(Math.abs(value.data[0][1]) * 1.05);
            }
          }
        }
      });

      if (graphData.xAxis.plotLines) {
        bigGraphInfo.xAxis.plotLines[0] = {
          value:
            graphData.xAxis.plotLines[0].value > 9.4 &&
            graphData.xAxis.plotLines[0].value < 9.9
              ? 9.4
              : graphData.xAxis.plotLines[0].value,
          id: 'currentAllocation',
          color: '#4ac6eb',
          width: 2,
          zIndex: 3
        };

        bigGraphInfo.xAxis.plotBands = {
          color: allocationColor(underAllocated),
          from: -1,
          to:
            graphData.xAxis.plotLines[0].value > 9.4 &&
            graphData.xAxis.plotLines[0].value < 9.9
              ? 9.4
              : graphData.xAxis.plotLines[0].value,
          id: 'currentAllocationBand'
        };
      }

      var benchmarkYAxisRange;

      // If they want to see "All Buyers" benchmarks then we go through this section to add the colored band for it.
      if (allBuyers) {
        var allSellerPricingBest =
          componentData.benchmarks.all.best * -100 || null;
        var allSellerPricingAvg =
          componentData.benchmarks.all.average * -100 || null;

        bigGraphInfo.yAxis.plotBands = [
          {
            id: 'benchmarksall',
            color: '#e0b0b0',
            from: allSellerPricingAvg,
            to: allSellerPricingBest,
            zIndex: 2
          }
        ];

        // Benchmarks are more than data - rescale the graph.
        benchmarkYAxisRange =
          Math.abs(allSellerPricingAvg || 0) >
          Math.abs(allSellerPricingBest || 0)
            ? Math.abs(allSellerPricingAvg || 0)
            : Math.abs(allSellerPricingBest || 0);

        if (benchmarkYAxisRange != null && benchmarkYAxisRange > yAxisRange) {
          yAxisRange = benchmarkYAxisRange;
        }
      } else if (likeMe) {
        // If they want to see "Like Me" benchmarks then we go through this section to add the colored band for it.
        // This code was changed to not allow both flags to be set to on simultaneously. If they are then "All
        // Buyers" will take precedence.
        var meSellerPricingBest =
          componentData.benchmarks.likeMe.best * -100 || null;
        var meSellerPricingAvg =
          componentData.benchmarks.likeMe.average * -100 || null;

        bigGraphInfo.yAxis.plotBands = [
          {
            id: 'benchmarksme',
            color: '#e0b0b0',
            from: meSellerPricingAvg,
            to: meSellerPricingBest,
            zIndex: 2
          }
        ];

        // Benchmarks are more than data - rescale the graph.
        benchmarkYAxisRange =
          Math.abs(meSellerPricingAvg || 0) > Math.abs(meSellerPricingBest || 0)
            ? Math.abs(meSellerPricingAvg || 0)
            : Math.abs(meSellerPricingBest || 0);

        if (benchmarkYAxisRange > yAxisRange) {
          yAxisRange = benchmarkYAxisRange;
        }
      }

      bigGraphInfo.yAxis.max = yAxisRange * 1.1;
      bigGraphInfo.yAxis.min = yAxisRange * -1.1;

      return bigGraphInfo;
    }
  };
}
